<vp-carousel
	[config]="config"
	[editableInStoryblok]="_editable"
	[items]="carouselItems"
/>
